<template>
  <tr
    class="odd:bg-white even:bg-gray-100 child:p-3 text-left text-xs cursor-pointer"
    @click="showChildren = !showChildren"
  >
    <td>
      <div
        class="flex items-center space-x-2"
        :style="{ paddingLeft: `${(depth * 16) + 8}px` }"
      >
        <button
          type="button"
          class="btn-icon btn-icon-default"
          @click.stop="showChildren = !showChildren"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 transition-transform duration-200"
            :class="[{ 'rotate-90': showChildren }]">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
        </button>

        <p class="w-60 text-wrap font-medium text-gray-700">
          {{ $props.tradeItem.name }}
        </p>
      </div>
    </td>

    <td />

    <td class="text-right" />

    <td class="text-right" />

    <td class="text-right" />

    <td class="text-right" />

    <td class="text-right" />

    <td class="text-right" />

    <td class="text-right" />

    <td class="text-right" />
  </tr>

  <template v-if="relevantChildren.length > 0 && showChildren">
    <PackageTradeItemRow
      v-for="childItem in relevantChildren"
      :key="childItem.id"
      :trade-item="childItem"
      :show-edit-buttons="showEditButtons"
      :package="package"
      :scrollable-container="scrollableContainer"
      :depth="depth + 1"
      @delete="$emit('delete', $event)"
    />
  </template>
</template>

<script setup lang="ts">
import Package from '@/models/Package';
import PackageTradeItem from '@/models/PackageTradeItem';
import TradeItem from '@/models/TradeItem';
import { usePackageTradeItemsStore } from '@/store/packageTradeItems';
import { useTradeItemsStore } from '@/store/tradeItems';
import { computed, ref } from 'vue';
import PackageTradeItemRow from './PackageTradeItemRow.vue';

const props = withDefaults(
  defineProps<{
    tradeItem: TradeItem;
    showEditButtons: boolean;
    package: Package;
    scrollableContainer: HTMLElement;
    depth?: number;
  }>(),
  {
    depth: 0,
  },
);

defineEmits<{
  (e: 'delete', packageTradeItem: PackageTradeItem): void;
}>();

const tradeItemsStore = useTradeItemsStore();
const packageTradeItemsStore = usePackageTradeItemsStore();

const packageTradeItemIds = computed(() => {
  return packageTradeItemsStore.models
    .where('package_id', props.package.id)
    .get()
    .map((packageTradeItem) => packageTradeItem.trade_item_id);
});

const hasPackageDescendant = (tradeItemId: Id): boolean => {
  if(packageTradeItemIds.value.some((id) => id === tradeItemId)) {
    return true;
  }

  return tradeItemsStore.models
    .where('parent_id', tradeItemId as number)
    .get()
    .some((child) => hasPackageDescendant(child.id));
};

const relevantChildren = computed(() => {
  return tradeItemsStore.models
    .where('parent_id', props.tradeItem.id)
    .orderBy('sort_order')
    .get()
    .filter((child) => hasPackageDescendant(child.id));
});

const showChildren = ref(relevantChildren.value.length > 0);
</script>

<style scoped></style>
